



























































import Api from "@/api/Api";
import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    canShow() {
      if (!this.advertisement) {
        return false;
      }
      return true;
    }
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.advertisement) {
        return;
      }
      await Api.singleton().call({
        method: "DELETE",
        resource: this.advertisement["@id"]
      });
      this.$emit("success");
      cb();
    }
  }
});
